import {FC} from "react";
import {useTranslations} from "next-intl";
import Image from "next/image";

import styles from './NoEventsBlock.module.scss';

import sad from "@/app/assets/images/sad_picture.png";
import ButtonElement from "@/shared/ButtonElement";

interface NoEventsBlockProps {
  className?: string;
}

const NoEventsBlock: FC<NoEventsBlockProps> = ({className = ''}) => {
  // random choice between 1, 2, 3
  const random = (Math.floor(Math.random() * 3) + 1).toFixed(0);
  const t = useTranslations(`Misc.NoEventsBlock.${random}`);


  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.root__icon}>
        <Image src={sad} alt={t("`NoEvents")}/>
      </div>
      <div className={styles.contents}>
        <div className={styles.contents__text}>
          <h3>{t("title")}</h3>
          <i>{t("story")}</i>
          <p>{t.rich("call", {
            strong: (children) => <strong>{children}</strong>,
          })}</p>
        </div>
        <ButtonElement
          className={styles.contents__button}
          href={"https://t.me/m/WQ2yb2o7ZjZi"}
          text={t("button")}
          blank
        >{t("button")}</ButtonElement>
      </div>
    </div>
  );
};

export default NoEventsBlock;
